import { render } from "./InspectUserAccount.vue?vue&type=template&id=46843916&scoped=true"
import script from "./InspectUserAccount.vue?vue&type=script&lang=js"
export * from "./InspectUserAccount.vue?vue&type=script&lang=js"

import "./InspectUserAccount.vue?vue&type=style&index=0&id=46843916&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46843916"]])

export default __exports__